<template>
  <div class="title">
    <transition name="fade">
      <div
        v-if="alerted"
        class="grid mb2">
        <lw-alert
          :type="alertType"
          :alert="alert"
          :title="alertTitle"
          :link="alertLink"
          :link-text="alertLinkText"
          :link-target="alertLinkTarget"
          @alerted="passAlert($event)" />
      </div>
    </transition>
    <nav
      v-if="back"
      class="c1 pl-margin pt1">
      <p><a
        href="#"
        class="action"
        @click.prevent="$router.go(-1)"><svg-left/>{{ backName }}</a></p>
    </nav>
    <header class="grid align-items-end relative grid-columns-3_sm">
      <div class="grid-column-span-2_sm">
        <h1
          :class="headerSize"
          class="mt1"><span
            v-if="prehead"
            class="block accent-text font-size-5 mb0 ls0">&nbsp;{{ prehead }}</span>{{ page }}</h1>
        <slot name="content"/>
      </div>
      <span class="action-slot align-self-start"><slot name="action"/></span>
    </header>
  </div>
</template>

<script>
import Left from '../svgs/Left'
import Alert from '../livewires/Alert'

export default {
  components: {
    svgLeft: Left,
    lwAlert: Alert
  },
  props: {
    back: {
      type: Boolean,
      default: false
    },
    backName: {
      type: String,
      default: 'Go back'
    },
    prehead: {
      type: String,
      default: ''
    },
    page: {
      type: String,
      default: ''
    },
    headerSize: {
      type: String,
      default: ''
    },
    notice: {
      type: [String, Boolean],
      default: false
    },
    noticeType: {
      type: String,
      default: null
    },
    noticeTitle: {
      type: [String, Boolean],
      default: false
    },
    noticeLink: {
      type: [String, Boolean],
      default: false
    },
    noticeLinkText: {
      type: String,
      default: null
    },
    noticeLinkTarget: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      alerted: false,
      alertTitle: false,
      alert: '',
      alertType: '',
      alertLink: false,
      alertLinkText: '',
      alertLinkTarget: '_blank'
    }
  },
  mounted () {
    if (this.$route.query.alert) {
      let message = this.$route.query.alert
      this.alertType = this.$route.query.type
      if (this.$route.query.action === 'archived' && this.$route.query.type === 'success') {
        message = message + ' was successfully archived'
      }
      if (this.$route.query.action === 'copied' && this.$route.query.type === 'success') {
        message = message + ' was successfully copied'
      }
      this.alert = message
      this.alerted = true
    }
    if (this.notice) {
      this.alertType = this.noticeType
      this.alert = this.notice
      this.alertTitle = this.noticeTitle
      this.alerted = true
      this.alertLink = this.noticeLink
      this.alertLinkText = this.noticeLinkText
      this.alertLinkTarget = this.noticeLinkTarget
    }
  },
  methods: {
    passAlert (event) {
      this.alerted = false
      this.$emit('closed', false)
    }
  }
}
</script>

<style scoped>
.title {
  margin-top: calc(var(--line) * 2.5);
  padding-top: var(--line);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
@media screen and (min-width: 48em) {
  .action-slot {
    position: absolute;
    top: calc(var(--line) * 0.667);
    right: var(--page-margin);
  }
  .title {
    margin-top: calc(var(--line) * 1.5);
    padding-top: calc(var(--line) * 4);
  }
}
</style>
